export default __webpack_public_path__ + "static/media/vuesax-linear-profile-2user.4810c93c.svg";